import React from 'react';
import PropTypes from 'prop-types';

/**
 * Modal header with navigation controls
 */
const EvaluationHeader = ({ caseIndex, onClose, onPrevious, onNext, hasPrevious, hasNext }) => {
  return (
    <div className="flex items-center justify-between border-b border-gray-800 px-6 py-4">
      <div className="flex items-center gap-3">
        <div>
          <h2 id="evaluation-modal-title" className="text-xl font-semibold text-white">
            Evaluation Details
          </h2>
          <p id="evaluation-modal-description" className="text-sm text-gray-300">
            Case #{caseIndex}
          </p>
        </div>
        <div className="flex items-center gap-2 ml-4">
          <button
            onClick={onPrevious}
            disabled={!hasPrevious}
            className="text-gray-300 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors p-2 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900"
            aria-label="Previous case"
            title="Previous case (←)"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button
            onClick={onNext}
            disabled={!hasNext}
            className="text-gray-300 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors p-2 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900"
            aria-label="Next case"
            title="Next case (→)"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
      <button
        onClick={onClose}
        className="text-gray-300 hover:text-white transition-colors p-2 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900"
        aria-label="Close evaluation modal"
        title="Close (ESC)"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

EvaluationHeader.propTypes = {
  caseIndex: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  hasPrevious: PropTypes.bool.isRequired,
  hasNext: PropTypes.bool.isRequired,
};

export default React.memo(EvaluationHeader);

